import React from "react"
import { useQueryClient } from "react-query"

export const useEpiEditMode = (path: string, pageData: any): void => {
	const queryClient = useQueryClient()

	const contentSavedCallback = (propertyUpdateData) => {
		const newState = { ...pageData }
		let shouldUpdateState = false
		propertyUpdateData.properties.forEach((property) => {
			if (property.successful === true) {
				Object.keys(pageData).forEach((key) => {
					if (key === property.name) {
						if (pageData[key]?.propertyDataType === "PropertyContentArea") {
							queryClient.invalidateQueries(path)
						} else {
							shouldUpdateState = true
							newState[key].value = property.value
						}
					}
				})
			}
		})
		if (shouldUpdateState) {
			queryClient.setQueryData(path, newState)
		}
	}

	const savedHandler = () => {
		if (window?.epi?.subscribe) {
			window.epi.subscribe("contentSaved", contentSavedCallback)
		}
	}

	React.useEffect(() => {
		// If window has already loaded, run handler
		if (document.readyState === "complete") {
			savedHandler()
		} else {
			window.addEventListener("load", savedHandler)
		}
		return () => window.removeEventListener("load", savedHandler)
	}, [pageData])
}
